module.exports = __webpack_public_path__ + "img/totalOrders.96212838.svg";